import { updatePayment } from 'data';

// update Payment to Elisa
export default async function submitPaymentToElisa(body, auth) {
    return updatePayment(body, auth);
}
